/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import { Field } from 'Util/Query';

/** @namespace Blog/Query/BlogComments/Query/BlogCommentsQuery */
export class BlogCommentsQuery {
    getQuery(options, replyDepth = 1) {
        const { pageSize, currentPage = 1, filter } = options;

        return new Field('blogComments')
            .addArgument('pageSize', 'Int!', pageSize)
            .addArgument('currentPage', 'Int!', currentPage)
            .addArgument('filter', 'BlogCommentsFilterInput!', filter)
            .addField(this.getCommentsItemField(replyDepth))
            .addFieldList([
                'total_count',
                'total_pages'
            ]);
    }

    getCommentsItemField(replyDepth) {
        return new Field('items')
            .addFieldList(this.getCommentsItemFields(replyDepth));
    }

    getCommentsItemFields(replyDepth) {
        if (replyDepth <= 0) {
            return [
                'author_email',
                'author_nickname',
                'comment_id',
                'creation_time',
                'text'
            ];
        }

        return [
            'author_email',
            'author_nickname',
            'comment_id',
            'creation_time',
            'text',
            new Field('replies')
                .addFieldList(this.getCommentsItemFields(replyDepth - 1))
        ];
    }

    getMutation(options, replyDepth = 1) {
        const { pageSize, commentData } = options;

        return new Field('addCommentToPost')
            .addArgument('pageSize', 'Int!', pageSize)
            .addArgument('input', 'addCommentToPostInput!', commentData)
            .addField(this.getCommentsField(replyDepth))
            .addFieldList([
                'total_count',
                'total_pages'
            ]);
    }

    getCommentsField(replyDepth) {
        return new Field('comments')
            .addFieldList(this.getCommentsItemFields(replyDepth));
    }
}

export default new BlogCommentsQuery();
